
(function ($) {
  'use strict';

  var PROVIDER_YOUTUBE = 'youtube';
  var PROVIDER_VIMEO = 'vimeo';

  var firstScriptTag = document.getElementsByTagName('script')[0];

  // support multiple players on a page, see: https://stackoverflow.com/a/18936798.
  var playerInfoList = [];

  // Sets up a YT video from a playerInfoList item.
  var createYoutubePlayer = function createYoutubePlayer(info) {
    /* eslint no-undef: "off" */
    /* eslint no-unused-vars: "off" */
    var player = new YT.Player(info.idString, info.config);
  };

  // Initialize a play button given a player, iframe, provider.
  var initPlayButton = function initPlayButton(player, iframe, provider) {
    var $posterContainer = $(iframe).closest('.video-poster-container');

    if ($posterContainer.length > 0) {
      var $playButton = $('.play-video-btn', $posterContainer);
      var $videoPoster = $('.video-poster', $posterContainer);
      var $videoContainer = $('.f--video-embed', $posterContainer);

      if ($playButton.length > 0 && $videoPoster.length > 0) {

        // Hide the iframe from screenreaders initially.
        $(iframe).attr('tabindex', '-1');
        $(iframe).attr('aria-hidden', 'true');

        $playButton.on('click', function () {
          $(iframe).focus();
          $(iframe).attr('tabindex', '0');
          $(iframe).attr('aria-hidden', 'false');
          $videoContainer.addClass('is-active');

          $videoPoster.fadeOut();

          if (provider === PROVIDER_YOUTUBE) {
            player.playVideo();
          }
          else if (provider === PROVIDER_VIMEO) {
            player.play();
          }
        });
      }
    }
  };

  // Initialize a youtube video from a .youtube-video div.
  var initYoutubeVideoEmbed = function initYoutubeVideoEmbed() {
    var self = this;

    var $youtubeContainer = $('.youtube-video', self);
    var youtubeId = $youtubeContainer.data('video-id');

    // ID with an increment at the end in case the same video appears twice.
    var idString = 'video-' + youtubeId + '-' + playerInfoList.length;
    $youtubeContainer.attr('id', idString);

    playerInfoList.push({
      idString: idString,
      config: {
        videoId: youtubeId,
        events: {
          onReady: function (event) {
            var player = event.target;
            var iframe = event.target.getIframe();

            initPlayButton(player, iframe, PROVIDER_YOUTUBE);
          },
          onStateChange: function (event) {
            var iframe = event.target.getIframe();
            var $posterContainer = $(iframe).closest('.video-poster-container');
            var $videoPoster = $('.video-poster', $posterContainer);
            var $videoContainer = $('.f--video-embed', $posterContainer);

            if (event.data === 0) {
              $videoPoster.fadeIn();
              $videoContainer.removeClass('is-active');
              $(iframe).attr('tabindex', '-1');
              $(iframe).attr('aria-hidden', 'true');
            }
          }
        }
      }
    });
  };

  // Initialize a vimeo video from a .vimeo-video div.
  var initVimeoVideoEmbed = function initVimeoVideoEmbed() {
    var self = this;

    // vimeo
    var $vimeoContainer = $('.vimeo-video', self);
    var vimeoId = $vimeoContainer.data('vimeo-id');

    // vimeo player create
    var vimeoPlayer;
    var vimeoScript = document.getElementById('vimeo-iframe-api');

    function createVimeoPlayer() {
      vimeoScript.onload = function () {
        vimeoPlayer = new Vimeo.Player($vimeoContainer, {
          id: vimeoId
        });

        vimeoPlayer.ready().then(function () {
          var iframe = $('iframe', $vimeoContainer.closest('.video-poster-container'));

          initPlayButton(vimeoPlayer, iframe, PROVIDER_VIMEO);
        });
      };
    }

    if ($vimeoContainer.length) {
      createVimeoPlayer();
    }
  };

  // Decide if we need to initialize Youtube or Vimeo.
  var initVideoEmbed = function initVideoEmbed() {
    if ($('.youtube-video', this).length > 0) {
      initYoutubeVideoEmbed.apply(this);
    }

    if ($('.vimeo-video', this).length > 0) {
      initVimeoVideoEmbed.apply(this);
    }
  };

  var addVimeoVendorScripts = function addVimeoVendorScripts() {
    if (document.getElementById('vimeo-iframe-api') === null && document.querySelector('.vimeo-video')) {
      var VimeoTag = document.createElement('script');
      VimeoTag.src = '//player.vimeo.com/api/player.js';
      VimeoTag.id = 'vimeo-iframe-api';
      firstScriptTag.parentNode.insertBefore(VimeoTag, firstScriptTag);
    }
  };

  var addYoutubeVendorScripts = function addYoutubeVendorScripts() {
    if (document.getElementById('youtube-iframe-api') === null && document.querySelector('.youtube-video')) {
      var YTtag = document.createElement('script');
      YTtag.src = '//www.youtube.com/iframe_api';
      YTtag.id = 'youtube-iframe-api';
      firstScriptTag.parentNode.insertBefore(YTtag, firstScriptTag);
    }

    window.onYouTubeIframeAPIReady = function () {
      if (playerInfoList.length > 0) {
        for (var i = 0; i < playerInfoList.length; i++) {
          createYoutubePlayer(playerInfoList[i]);
        }
      }
    };
  };

  // Boilerplate drupal behavior.
  window.DP.behaviors.videoEmbed = {
    attach: function (context) {
      // Currently we do not support embedded video loaded via AJAX.
      if (context === document) {
        // Vimeo vendor scripts must be added before api calls.
        once('videoEmbedVimeo', 'body', context)
          .forEach(() => {
            addVimeoVendorScripts();
          });
        // $('body', context).once('videoEmbedVimeo').each(function () {
        //   addVimeoVendorScripts();
        // });

        once('videoEmbed', '.cc--video-with-text', context)
          .forEach((e) => {
            initVideoEmbed.apply(e);
          });
        // $(context).find('.cc--video-with-text').once('videoEmbed').each(function () {
        //   initVideoEmbed.apply(this);
        // });

        // Youtube vendor scripts must be added only after 'playerInfoList' is ready.
        once('videoEmbedYoutube', 'body', context)
          .forEach(() => {
            addYoutubeVendorScripts();
          });
        // $('body', context).once('videoEmbedYoutube').each(function () {
        //   addYoutubeVendorScripts();
        // });
      }
    }
  };

}(jQuery));
